// Admin-specific constants & mock data (extracted from AdminDashboard.jsx)

// Mock workshop bookings for demo/leads fallback
export const mockWorkshopBookings = [
  {
    id: 1,
    contact: 'Bart Stevens',
    email: 'bart.stevens@digitaldynamics.be',
    phone: '+32 479 55 12 34',
    company: 'Digital Dynamics',
    industry: 'Technology',
    teamSize: 35,
    preferredDate: 'Maart 2025',
    status: 'pending',
    dateSubmitted: '12/11/2025',
    interests: 'HR chatbot implementation, employee self-service',
  },
  {
    id: 2,
    contact: 'Lisa Peeters',
    email: 'lisa.peeters@medicare.be',
    phone: '+32 492 33 33 44',
    company: 'MediCare Plus',
    industry: 'Healthcare',
    teamSize: 12,
    preferredDate: 'Flexible',
    status: 'pending',
    dateSubmitted: '12/8/2025',
    interests: 'Predictive analytics for retention',
  },
  {
    id: 3,
    contact: 'Laura Vermeersch',
    email: 'laura@edunova.be',
    phone: '+32 476 94 22 11',
    company: 'EduNova Academy',
    industry: 'Education',
    teamSize: 20,
    preferredDate: 'Q1 2025',
    status: 'confirmed',
    dateSubmitted: '12/5/2025',
    interests: 'AI for recruitment, skills assessment',
  },
  {
    id: 4,
    contact: 'Sophie Vandenberghe',
    email: 'sophie@technova.be',
    phone: '+32 477 14 85 96',
    company: 'TechNova Solutions',
    industry: 'Technology',
    teamSize: 18,
    preferredDate: 'Februari 2025',
    status: 'pending',
    dateSubmitted: '12/5/2025',
    interests: 'AI governance and ethics workshop',
  },
  {
    id: 5,
    contact: 'Nathalie Dubois',
    email: 'nathalie.dubois@bluesky.be',
    phone: '+32 492 77 88 99',
    company: 'BlueSky Consulting',
    industry: 'Professional Services',
    teamSize: 10,
    preferredDate: 'Maart 2025',
    status: 'pending',
    dateSubmitted: '12/4/2025',
    interests: 'AI governance and ethics workshop',
  },
];

export const mockPendingUseCases = [];

export const mockHotLeads = [
  {
    company: 'BelgaTelecom',
    industry: 'Telecommunications',
    size: '1000+',
    contact: 'Annelies Van Hoof',
    email: 'annelies.vanhoof@belgatel.com.be',
    phone: '+32 491 88 77',
    role: 'Talent Director',
    score: 3.8,
    date: '11/10/2025',
  },
];

// Score labels (1-6 Likert scale)
export const scoreLabels = [
  '',
  'Helemaal niet',
  'Nauwelijks',
  'In beperkte mate',
  'In redelijke mate',
  'In grote mate',
  'Helemaal',
];

// Colors for spider diagram lines
export const comparisonColors = [
  '#2563eb', // blue-600
  '#3b82f6', // blue
  '#22c55e', // green
  '#a855f7', // purple
  '#ef4444', // red
  '#06b6d4', // cyan
];

// Assessment questions grouped by dimension (for drill-down comparison)
export const adminAssessmentQuestions = {
  strategy: {
    id: 'strategy',
    title: 'Strategie',
    questions: [
      { id: 1, text: 'In welke mate heeft uw organisatie een duidelijke AI-visie als onderdeel van de algemene bedrijfsstrategie?' },
      { id: 2, text: 'In welke mate heeft uw HR-afdeling een eigen AI-strategie of roadmap?' },
      { id: 3, text: 'In welke mate heeft u reeds concrete AI use cases voor HR geïdentificeerd?' },
      { id: 4, text: 'In welke mate zijn AI-initiatieven binnen HR afgestemd op de algemene bedrijfsdoelstellingen?' },
      { id: 5, text: 'In welke mate is er leiderschapssteun voor AI-initiatieven binnen HR?' },
    ],
  },
  governance: {
    id: 'governance',
    title: 'Governance',
    questions: [
      { id: 6, text: 'In welke mate bent u bekend met relevante AI-wetgeving zoals de AI Act en AVG/GDPR?' },
      { id: 7, text: 'In welke mate heeft uw organisatie een duidelijk AI-beleid met richtlijnen voor verantwoord gebruik?' },
      { id: 8, text: 'In welke mate is het duidelijk welke AI-tools wel en niet mogen worden gebruikt binnen uw organisatie?' },
      { id: 9, text: 'In welke mate is "human in the loop" belangrijk bij AI-beslissingen met HR-impact?' },
      { id: 11, text: 'In welke mate is er een specifiek AI-budget beschikbaar voor HR-initiatieven?' },
    ],
  },
  technology: {
    id: 'technology',
    title: 'Technologie & Data',
    questions: [
      { id: 12, text: 'In welke mate is uw medewerkersdata gecentraliseerd en gemakkelijk toegankelijk?' },
      { id: 13, text: 'In welke mate is uw HR-data van hoge kwaliteit en betrouwbaar?' },
      { id: 14, text: 'In welke mate denkt u dat uw HR-processen klaar zijn voor AI-digitalisering?' },
      { id: 15, text: 'In welke mate zijn uw HR-systemen geïntegreerd met andere bedrijfsplatformen?' },
    ],
  },
  people: {
    id: 'people',
    title: 'Mensen & Change',
    questions: [
      { id: 16, text: 'In welke mate ziet het HR-team de voordelen van de implementatie en het gebruik van AI-tools in HR?' },
      { id: 17, text: 'In welke mate gelooft de individuele HR-medewerker dat AI hem of haar helpt om efficiënter te kunnen werken?' },
      { id: 18, text: 'In welke mate is er enthousiasme binnen het team om gecontroleerd te experimenteren met AI?' },
      { id: 19, text: 'In welke mate hebben HR-medewerkers een basistraining over AI in HR gehad?' },
      { id: 20, text: 'In welke mate lukt het HR-medewerkers om AI op een consistente manier toe te passen in hun dagelijks werk?' },
      { id: 22, text: 'In welke mate hebben HR-medewerkers tijd en ruimte om te oefenen met AI-tools?' },
      { id: 23, text: 'In welke mate worden goede AI-praktijken zichtbaar gemaakt en gedeeld binnen het team?' },
      { id: 24, text: 'In welke mate wordt de kwaliteit en effectiviteit van AI-toepassingen voor HR gemonitord?' },
    ],
  },
};

// Score color helpers
export const getScoreColor = (score) => {
  if (score >= 70) return 'text-green-500';
  if (score >= 40) return 'text-blue-500';
  return 'text-red-500';
};

export const getMaturityLabel = (score) => {
  if (score >= 70) return { label: 'Advanced', bg: 'bg-green-100 text-green-700' };
  if (score >= 40) return { label: 'Developing', bg: 'bg-blue-100 text-blue-700' };
  return { label: 'Early Stage', bg: 'bg-red-100 text-red-700' };
};
